'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function FaceVeryHappy(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C4.67891 2 2 4.67891 2 8C2 11.3211 4.67891 14 8 14C11.3211 14 14 11.3211 14 8C14 4.67891 11.3211 2 8 2ZM8 3.28571C10.6311 3.28571 12.7143 5.36893 12.7143 8C12.7143 10.6311 10.6311 12.7143 8 12.7143C5.36893 12.7143 3.28571 10.6311 3.28571 8C3.28571 5.36893 5.36893 3.28571 8 3.28571Z", fill: "currentColor" }),
        React__default.default.createElement("circle", { cx: "10", cy: "7", r: "1", fill: "currentColor" }),
        React__default.default.createElement("circle", { cx: "6", cy: "7", r: "1", fill: "currentColor" }),
        React__default.default.createElement("path", { d: "M11.6051 8.93955C11.685 9.01506 11.7251 9.11067 11.7251 9.22619C11.7166 10.9698 9.49994 12 8 12C6.50006 12 4.21338 11 4.21338 9.2262C4.21342 9.12807 4.25117 9.01507 4.32677 8.93955C4.40675 8.86402 4.50005 8.82617 4.60675 8.82617H11.3251C11.4362 8.82617 11.5295 8.86402 11.6051 8.93955Z", fill: "currentColor" })));
}

module.exports = FaceVeryHappy;
//# sourceMappingURL=FaceVeryHappy.js.map
